import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'

export default function PageTitle(props) {
    return (
        <>
            <Typography sx={{ margin: '10px 0 4px 0', fontWeight: 300 }} variant='h6' align='center'>
                {props.children}
            </Typography>
            <Divider sx={{ mb: '9px' }} />
        </>
    )
}
